<template>
    <div class="sau-bx">
        <div class="sau-preview-bx">
            <table class="sau-bx-table">
                <tbody>
                    <tr v-for="domain in domains" :key="domain.domain_no">
                        <td width="40"><span class="sau-dot xs"><i class="fas fa-certificate float-left pr-2"></i></span></td>
                        <td><a :href="`/service/domains/${domain.id}/details`" class="sau-linx-hover gray">{{domain.name}}</a></td>
                        <td align="right" class="text-muted sau-font xs">{{domain.expires}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props:['domains']
}
</script>

<style>

</style>
